export class PayByInvoiceType {
    static KEEP_UP_CAR = 'keepupcar';
    static PROVIDER = "provider";
}

Object.freeze(PayByInvoiceType);